module.exports = __webpack_public_path__ + "img/map-mobile.a0b8d99e.png";